import { select, takeLatest, put } from "redux-saga/effects";
import { current, getType } from "@reduxjs/toolkit";
import { actions } from "@/reducers/autonomos";
import { types } from "@gc-npm/reducers.modals-reducer";

// abe-quitar

import {
  putInStore,
  allDevicesSelector,
  deviceListSelector,
  deviceDictionarySelector,
  selectedProductsSelector,
} from "./utils";

let deviceModalMap = null;
// normalizers
import {
  normalizeDeviceDictionary,
  normalizeDeviceList,
  normalizeProducts,
  normalizeDeviceProduct,
  normalizeDeviceInfo,
} from "./normalizer";

// api
import { fetchDevices, fetchDeviceData } from "./api";

const categories = ["MÓVIL"];

function* getDeviceDictionarySaga({ payload }) {
  try {
    let dictionary = yield fetchDevices("FUSION_AV");
    dictionary = normalizeDeviceDictionary(dictionary, "r2r");

    const list = normalizeDeviceList(dictionary, "mv");
    const product = normalizeDeviceProduct(list);

    yield putInStore(actions.INIT_DEVICES, { dictionary, list, product });
  } catch (e) {
    yield putInStore(actions.INIT_DEVICES_FAIL);
    console.log(e);
  }
}

function* initDevicesSaga(payload) {}

function* setFilterSaga({ payload }) {
  try {
    let devices = yield select(allDevicesSelector);

    switch (payload) {
      case "TODOS":
        break;

      case "OTROS":
        devices = devices.filter((dev) => {
          return (dev?.filters?.category || []).reduce(
            (acc, filter) => acc && !categories.includes(filter),
            true
          );
        });
        break;

      default:
        devices = devices.filter((dev) => {
          const res = (dev?.filters?.category || []).reduce((acc, item) => {
            return payload.includes(item) || acc;
          }, false);

          return res;
        });

        break;
    }

    yield putInStore(actions.SET_FILTERED_DEVICES, {
      list: devices,
      filter: payload,
    });
  } catch (e) {
    console.log(e);
  }
}

function* setDeviceQuerySaga(payload) {
  try {
    let devices = yield select(deviceListSelector);

    devices = devices.filter((dev) => {});
  } catch (e) {}
}

function* getSelectProductState({ category, productOffering }) {
  let currentProductState = yield select(selectedProductsSelector);
  currentProductState =
    currentProductState[category]?.products?.[productOffering];

  return currentProductState;
}

function getProductNextState({ product, actionType }) {
  let newState = { ...product };

  switch (actionType) {
    case "card/click":
      if (newState.count > 1) {
        return newState;
      }

      newState.count = newState.count ? 0 : 1;
      return newState;

    case "counter/increment":
      newState.count += 1;
      return newState;

    case "counter/decrement":
      newState.count -= 1;
      return newState;

    default:
      return { ...newState };
  }
}

function getAdditionalPricesCategoryState({ categoryState, category }) {
  let filteredProductsWithAP = Object.values(categoryState).filter(
    (value) => value?.count > 0
  );

  filteredProductsWithAP = filteredProductsWithAP.map((product) => {
    return product.additionalPrice;
  });

  return filteredProductsWithAP;
}

function* getCategoryState({
  productState,
  productOffering,
  category,
  selectType,
}) {
  let currentCategory = yield select(selectedProductsSelector);
  currentCategory = currentCategory[category]?.products;

  let newCategory = {};

  switch (selectType) {
    case "unique":
      const categoryArr = Object.entries(currentCategory);

      categoryArr.map(([key, value]) => {
        if (productOffering == key) {
          newCategory[key] = productState;
          console.log({ productState });
        } else {
          newCategory[key] = { ...value, count: 0 };
        }
      });

      return newCategory;

    default:
      newCategory = { ...currentCategory };
      newCategory[productOffering] = productState;

      return newCategory;
  }
}

function* selectProductSaga({ payload }) {
  try {
    const { actionType, productProps, category, selectType } = payload;
    const productOffering = productProps.productOffering;

    // get product from store
    const product = yield getSelectProductState({
      productOffering,
      category,
    });

    // update PRODUCT state acordingly with product and action
    const productState = getProductNextState({ product, actionType });

    const categoryState = yield getCategoryState({
      productState,
      productOffering,
      category,
      selectType,
    });

    const additionalPrices = getAdditionalPricesCategoryState({
      categoryState,
    });

    yield putInStore(actions.SET_SELECTED_PRODUCT, {
      categoryState,
      category,
      additionalPrices,
    });
  } catch (e) {
    console.log(e);
  }
}

function* initConfigProducts(payload) {
  const normalizedProducts = normalizeProducts(payload);

  yield putInStore(actions.SET_PRODUCT_CATEGORIES, normalizedProducts);
}

function* initProductSaga({ payload }) {
  try {
    const sections = Object.values(payload);

    for (let section of sections) {
      switch (section.type) {
        case "config":
          yield initConfigProducts(section.value);
          break;

        default:
      }
    }
  } catch (e) {
    console.log(e);
  }
}

function setDeviceModalMap(deviceInfo) {
  if (!deviceModalMap) {
    deviceModalMap = new Map();
  }

  if (deviceInfo?.dictionary) {
    for (let device of Object.values(deviceInfo.dictionary)) {
      const color = device?.color?.hex;
      let storage = device?.storage?.text;

      if (storage) {
        storage = storage.replaceAll(" ", "");
      }

      deviceModalMap.set(`${color} ${storage}`, device);
    }
  }
}

function getDeviceModalMap(color, storage) {
  if (deviceModalMap) {
    let currDevice = deviceModalMap.get(`${color} ${storage}`);

    if (!currDevice) {
      currDevice = deviceModalMap.values().next().value;
    }

    return currDevice;
  }

  return null;
}

// abe-cambiar
function* openDeviceModalSaga({ payload }) {
  try {
    const { aliasUrl, color, storage, alias } = payload;

    let deviceInfo = yield fetchDeviceData(aliasUrl);
    deviceInfo = normalizeDeviceInfo(deviceInfo);

    let finalStorage = storage?.text;

    if (finalStorage) {
      finalStorage = finalStorage.replaceAll(" ", "");
    }

    setDeviceModalMap(deviceInfo);
    const currentDevice = getDeviceModalMap(color?.hex, finalStorage);

    yield putInStore(actions.SET_DEVICE_MODAL_INFO, {
      aliasUrl,
      currentDevice,
      storageList: deviceInfo?.storageList,
      colorList: deviceInfo?.colorList,
      alias: alias,
    });
  } catch (e) {
    console.log(e);
  }
}

function* changeDevicePropSaga({ payload }) {
  try {
    const { color, storage, alias } = payload;
    let deviceListIndex = null;
    let finalStorage = storage;
    const deviceList = yield select(deviceListSelector);

    if (finalStorage) {
      finalStorage = finalStorage.replaceAll(" ", "");
    }

    const currentDevice = getDeviceModalMap(color, finalStorage);

    deviceList.forEach((device, i) => {
      if (device?.alias === alias) {
        deviceListIndex = i;
      }
    });

    yield putInStore(actions.SET_NEW_DEVICE_PROPS, {
      currentDevice: currentDevice,
      deviceListIndex: deviceListIndex,
    });
  } catch (e) {
    console.log(e);
  }
}

function* closeDeviceModalSaga() {
  deviceModalMap = null;
}

function* filterDevicesByNameSaga({ payload }) {
  const deviceList = yield select(allDevicesSelector);

  const filteredDevices = deviceList.filter((device) => {
    let title = device?.title?.text;

    if (title && payload) {
      title = title.toLowerCase();
      return title.includes(payload.toLowerCase());
    }

    return true;
  });

  yield putInStore(actions.SET_FILTERED_DEVICES, {
    list: filteredDevices,
    query: payload,
  });
}

export default [
  takeLatest(getType(actions.GET_DEVICE_DICTIONARY), getDeviceDictionarySaga),
  takeLatest(getType(actions.SET_FILTER), setFilterSaga),
  takeLatest(getType(actions.INIT_DEVICES), initDevicesSaga),
  takeLatest(getType(actions.SET_DEVICE_QUERY), setDeviceQuerySaga),
  takeLatest(getType(actions.SELECT_PRODUCT), selectProductSaga),
  takeLatest(getType(actions.INIT_PRODUCT_CATEGORIES), initProductSaga),
  takeLatest(getType(actions.OPEN_DEVICE_MODAL), openDeviceModalSaga),
  takeLatest(getType(actions.CHANGE_DEVICE_PROP), changeDevicePropSaga),
  takeLatest(getType(actions.CLOSE_DEVICE_MODAL), closeDeviceModalSaga),
  takeLatest(getType(actions.FILTER_DEVICES_BY_NAME), filterDevicesByNameSaga),
];
